// extracted by mini-css-extract-plugin
export var connectText = "mailing-list-banner-module--connectText--ab5b5";
export var container = "mailing-list-banner-module--container--4b993";
export var joinButton = "mailing-list-banner-module--joinButton--3496c";